/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import {
  CustomDateFormatService,
  DateFormat
} from '../../../../../../../../../services/custom-date-format/custom-date-format.service';
import { Component, Input, OnInit } from '@angular/core';
import { faChevronDown, IconDefinition } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'record-title',
  templateUrl: './record-title.component.html',
  styleUrls: ['./record-title.component.scss'],
  standalone: false
})
export class RecordTitleComponent implements OnInit {
  @Input() itemIcon!: IconDefinition;
  @Input() title: string = '';
  @Input() timestamp?: string;
  _formattedTimestamp?: string;
  constructor(public customDateFormatService: CustomDateFormatService) {}

  ngOnInit(): void {
    if (this.timestamp)
      this._formattedTimestamp = this.customDateFormatService.formatDate(
        this.timestamp,
        DateFormat.short
      );
  }
}
